// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3003M","upload":"Small_upload__1GxwT","imageWrap":"Small_imageWrap__2I2a3","removeBtn":"Small_removeBtn__2tGS9"};